import React, { useEffect, useMemo, useState } from "react"
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Grid,
    Typography,
    IconButton,
    Alert,
    Stack,
    Divider,
    CircularProgress,
    Container
} from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import moment from "moment"
import CloseIcon from "@mui/icons-material/Close"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import NumbersIcon from "@mui/icons-material/Numbers"
import EventIcon from "@mui/icons-material/Event"
import BusinessIcon from "@mui/icons-material/Business"
import PlaceIcon from "@mui/icons-material/Place"
import StoreIcon from "@mui/icons-material/Store"
import LockIcon from "@mui/icons-material/Lock"
import SaveIcon from "@mui/icons-material/Save"
import SimpleDialog from "../../Dialogs/SimpleDialog"
import { Edit, EditLocation, EditNote } from "@mui/icons-material"
import * as helpers from "../../ventas/facturacion/helpers";

import * as apiRemitos from "../api"
import * as apiVtasFact from "../../ventas/facturacion/api"
import EstadoChip from "./EstadoChip"
import FormDatosRemitos from "./FormDatosRemitos"
import FormItems from "./FormItems"
import Footer from "./Footer"
import { putData } from "../../../services/library"
import {useToast} from "../../../Hooks/UseToast"
import Notify from "../../Notify"

const ESTADOS_BLOQUEADOS = [2, 3] 

const mapRemitoToForm = (remito) => {
    const [puntoVenta = "", nroComprobante = ""] = remito?.nro ? remito.nro.split("-") : [];

    return {
        id_remito: remito?.id_remito || null,
        puntoVenta,
        nroComprobante,
        fecha: remito?.fecha ? moment(remito?.fecha).format("YYYY-MM-DD") : null,
        id_empresa: remito?.id_empresa,
        id_sucursal_remite: remito?.id_sucursal_remite ?? "",
        id_tipo_cliente: remito?.id_tipo_cliente ?? "",
        id_cliente: remito?.id_cliente ?? "",
        id_direccion_entrega: remito?.id_direccion_entrega ?? "",
        id_chofer: remito?.id_chofer ?? "",
    }
}

function DialogEditarRemito({ open, onClose, remito, onSave, setRemitos, setOpen, getRemitos}) {
    const [dataRemito, setDataRemito] = useState(() => mapRemitoToForm(remito))
    const { Toast, showToast } = useToast();
    const [clientes, setClientes] = useState([]);
    const [clienteSeleccionado, setClienteSeleccionado] = useState();
    const [direcciones, setDirecciones] = useState();
    const [direccionSeleccionada, setDireccionSeleccionada] = useState();
    const [paramsNegocios, setParamsNegocios] = useState(); //parametros que contienen donde tengo que ir a buscar los datos segun el negocio del cliente (granel, envasado, etc).
    const [um, setUM] = useState();
    const [productos, setProductos] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [choferes, setChoferes] = useState([]);
    const [itemsRemito, setItemsRemito] = useState([]);
    const [disBtn, setDisBtn]=useState();
    const [notify, setNotify]=useState({open:false});
    const [itemsEliminar, setItemsEliminar]=useState([]);
    const [lineasCompletas, setLineasCompletas]=useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const paramsNegocio = await apiRemitos.fetchParamsNegocio()
            apiRemitos.getEmpresas(setEmpresas);
            apiRemitos.getChoferes(remito.id_sucursal_remite, setChoferes);
            apiVtasFact.getUnidadesMedida(setUM);
            apiRemitos.obtenerProductos(setProductos);
            apiRemitos.getItems(remito.id_remito, setItemsRemito);
            apiRemitos.getSucursalesEmpresa(dataRemito.id_empresa, setSucursales);

            apiRemitos.getClienteSeleccionado(dataRemito.id_tipo_cliente ,dataRemito.id_cliente, (data) => {
                if (data) {
                    setClientes([data]);
                    setClienteSeleccionado(data);
                }
            });

            const clienteSeleccionado = { id: dataRemito.id_cliente, id_negocio_cliente: remito.id_tipo_cliente, direccion_fiscal: "" }
            if (!!paramsNegocio) {
                apiVtasFact.fetchDomicilios(clienteSeleccionado, (listaDirecciones) => {
                    setDirecciones(listaDirecciones || []);

                    if (dataRemito.id_direccion_entrega && Array.isArray(listaDirecciones)) {
                        const seleccionada = listaDirecciones.find(
                            (d) => d.id === dataRemito.id_direccion_entrega
                        );
                        if (seleccionada) {
                            setDireccionSeleccionada(seleccionada);
                        }
                    }
                }, paramsNegocio);

            }
        }
        fetchData();
    }, [open, remito]);

    const almacenar = (e) => {
        setDataRemito({ ...dataRemito, [e.target.name]: e.target.value });
    };

    const remitoParams = {
        almacenar,
        dataRemito,
        setDataRemito,
        clientes,
        setClientes,
        clienteSeleccionado,
        setClienteSeleccionado,
        direccionSeleccionada,
        setDireccionSeleccionada,
        direcciones,
        setDirecciones,
        sucursales,
        setSucursales,
        choferes,
        setChoferes,
        empresas,
    };

    const handleOnChangeItemsRemito = (e, index) => {
        const values = [...itemsRemito];
        const updatedValue = e.target.name;
        values[index][updatedValue] = e.target.value;

        setItemsRemito(values);
    };

    const handleOnChangeUM = (e, index) => {
        const idProductoLinea = itemsRemito[index].idProducto;

        if (!!idProductoLinea) {
            const productoValido = helpers.validaUMProducto(
                productos,
                idProductoLinea,
                e.target.value
            );

            setItemsRemito((prev) => {
                const newItems = [...prev];
                newItems[index].unidadMedida = e.target.value;
                newItems[index].descUnidadMedida =
                    um
                        .find((un) => un.id === e.target.value)
                        ?.abreviatura?.toUpperCase() || "";
                newItems[index].idProducto = !productoValido
                    ? ""
                    : itemsRemito[index].idProducto;
                newItems[index].descripcion = "";
                return newItems;
            });
            return;
        }

        setItemsRemito((prev) => {
            const newItems = [...prev];
            newItems[index].unidadMedida = e.target.value;
            newItems[index].descUnidadMedida =
                um.find((un) => un.id === e.target.value)?.abreviatura?.toUpperCase() ||
                "";
            return newItems;
        });
    };

    const handleNuevoItem = () => {
        const values = [...itemsRemito];
        values.push({
            cantidad: "",
            unidadMedida: "",
            idProducto: "",
        });
        setItemsRemito(values);
        setTimeout(() => {
            window.scrollTo({
                top: document.body.scrollHeight,
                behavior: "smooth",
            });
        }, 100);
    };

    const handleOnChangeProducto = (producto, index) => {
        const nuevosItems = [...itemsRemito];

        nuevosItems[index].idProducto = producto.idproducto;

        nuevosItems[index].descripcion = producto.detalle_factura;

        nuevosItems[index].valor_iva = producto.valor_iva;

        setItemsRemito(nuevosItems);
    };

    const handleEliminarItem = (index) => {
        const values = [...itemsRemito];

        const idItemEliminado = values[index]?.id_item;
        setItemsEliminar([...itemsEliminar, idItemEliminado])

        values.splice(index, 1);
        setItemsRemito(values);
        
    };
        

    const itemsParams = {
        itemsRemito,
        um,
        productos,
        handleOnChangeItemsRemito,
        handleOnChangeUM,
        handleNuevoItem,
        handleOnChangeProducto,
        handleNuevoItem,
        handleEliminarItem,
        lineasCompletas,
        setLineasCompletas
    };

    const enviar = async () => {
        setDisBtn(true)
        await apiRemitos.editarRemito({
            dataRemito,
            itemsRemito,
            itemsEliminar,
            clienteSeleccionado,
            direccionSeleccionada,
            setNotify,
            getRemitos, 
            setOpenDialog:setOpen,
            setDisBtn
        });
    };

    const Children = (
        <Container maxWidth="xl" sx={{py:2}}>
            {itemsRemito && (<FormDatosRemitos {...remitoParams} />)}
            <FormItems {...itemsParams} />
            <Footer
                clienteSeleccionado={clienteSeleccionado}
                enviar={enviar}
                dataRemito={dataRemito}
                hayCliente={true}
                disBtn={disBtn}
                setOpen={setOpen}
                lineasCompletas={lineasCompletas}
                itemsRemito={itemsRemito}
            />
            {
                notify.open && (
                    <Notify
                        open={notify?.open}
                        severity={notify?.severity}
                        mensaje={notify?.mensaje}
                        handleClose={notify?.handleClose} 
                    />

                )
            }
        </Container>
    )

    const icon = <EditNote />
    return (
        <>
            <SimpleDialog 
                fullScreen={true} 
                width={"xl"} 
                open={open} 
                children={Children} 
                titulo={"Modificacion De Remito"} 
                icono={icon} 
                borderRadius={0} 
                onClose={onClose} 
            />

        </>
        
    )
}

export default DialogEditarRemito
